export const VERSION_CGU = '07/03/2018';
export const TIMEOUT_DEFAULT = 600000; // 10 minutes
export const HEADER_DRAFT_VERSION = 'x-draft-version';



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/constants/application.constants.ts